export default __webpack_public_path__ + "static/media/background-programas.2c991398.png";